import React, { useState, useEffect } from "react";

import useStyles from "./style";
import { useData } from "../../../firebase/DataProvider";

import { useHistory } from "react-router-dom";

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import IconButton from "@material-ui/core/IconButton";
import Badge from "@material-ui/core/Badge";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import Menu from "@material-ui/core/Menu";
import Typography from "@material-ui/core/Typography";
import MenuItem from "@material-ui/core/MenuItem";

function WithTittleCart({ onClick, title, totalCart }) {
  const [hideNotif, setHideNotif] = useState(false);
  const classes = useStyles();
  const history = useHistory();
  const {level} = useData()

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [anchorEl, setAnchorEl] = useState(false);

  useEffect(() => {
    const topNavbar = () => {
      if (window.scrollY >= 50) {
        setHideNotif(true);
      } else {
        setHideNotif(false);
      }
    };

    window.addEventListener("scroll", topNavbar);

    return () => {
      window.removeEventListener("scroll", topNavbar);
    };
  }, []);

  return (
    <div
      className={classes.header}
      style={
        hideNotif
          ? {
              backgroundColor: "white",
              top: 0,
              transition: "all .2s ease-out",
            }
          : { top: 40 }
      }
    >
      <div className={classes.wrapHeader}>
        <div className={classes.wrapTitle}>
          <Typography
            style={
              hideNotif
                ? {
                    color: "black",
                    transition: "all .2s ease-out",
                  }
                : null
            }
            className={classes.title}
          >
            {title}
          </Typography>
        </div>
        <div>
          <IconButton
            aria-controls="simple-menu"
            aria-haspopup="true"
            onClick={handleClick}
            size="small"
          >
            <MoreVertIcon
              className={hideNotif ? classes.icCart : classes.icCartBlack}
            />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem onClick={() => history.push("/akun/bantuan")}>
              <Typography style={{ fontSize: "12px" }}>Bantuan</Typography>
            </MenuItem>
            {level?.is_active && ( <MenuItem onClick={() => history.push("/akun/pengaturan")}>
              <Typography style={{ fontSize: "12px" }}>
              Pengaturan
              </Typography>
            </MenuItem>)}
           
          </Menu>
          <IconButton size="small" onClick={() => history.push("/cart")}>
            <Badge badgeContent={totalCart} color="secondary">
              <ShoppingCartIcon
                className={hideNotif ? classes.icCart : classes.icCartBlack}
              />
            </Badge>
          </IconButton>
        </div>
      </div>
    </div>
  );
}

export default WithTittleCart;
